<script lang="ts" setup>
defineProps({
	type: {
		type: String,
		default: 'default',
	},
	size: {
		type: String,
		default: 'md',
	},
	solid: {
		type: Boolean,
		default: false,
	},
	outline: {
		type: Boolean,
		default: false,
	},
})
</script>

<template>
	<button
		class="bs-button"
		:class="[
			`bs-button--${type}`,
			`bs-button--${size}`,
			solid && 'bs-button--solid',
			outline && 'bs-button--outline',
		]"
		@keyup.enter="$emit('click')"
	>
		<slot />
	</button>
</template>
